import React from 'react';
import { hour24ToMeridiem } from 'helpers/datetime';
import moment from 'moment-timezone';

const ATHeader = ({ at, job, tz, eventTitle }) => {
  if (!job) return null;

  if (job.currentState !== 'pending') {
    return (
      <div className="at-header">
        <div className="at-header__avatar">
          {at.profilePic ? (
            <img src={at.profilePic} alt="AT" className="at-header__avatar-img" />
          ) : (
            <span className="material-icons-outlined" style={{ fontSize: 42, color: '#fff' }}>person</span>
          )}
        </div>
        <div className="at-header__info">
          <div className="at-header__name">{at.name}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="at-header">
      <div className="at-header__avatar">
        {at.profilePic ? (
          <img src={at.profilePic} alt="AT" className="at-header__avatar-img" />
        ) : (
          <span className="material-icons-outlined" style={{ fontSize: 42, color: '#fff' }}>person</span>
        )}
      </div>
      <div className="at-header__info">
        <div className="at-header__name">{at.name}</div>
        <div className="at-header__details">
          Application for {eventTitle}
          <br />
          Shift:{' '}
          {`${hour24ToMeridiem(job.start)} \u2013 ${hour24ToMeridiem(job.end)} on ${moment(job.startDate).format(
            'MM/DD/YYYY'
          )}`}{' '}
          &middot; Applied on {moment.tz(job.appliedDate, tz).format('MM/DD/YYYY')}
        </div>
      </div>
    </div>
  );
};

export default ATHeader;
